// The ANZ Worldline preprod host doesn't take real payments, so it drives the
// dev/test behaviour: $1 amounts and Google Pay TEST mode without a merchant ID.
export const isWorldlinePreprod = (worldlineHost: string) => worldlineHost.includes('.preprod.');
